import type { components } from "./generated/openapiSchema";

/**
 * A request or response body of the DMW API by its OpenAPI schema name. The types are
 * generated from the server's OpenAPI document (`npm run api:generate`), never written by
 * hand, so the compiler reports any drift between a decoder and the server's contract.
 */
export type ApiSchema<Name extends keyof components["schemas"]> = components["schemas"][Name];

/**
 * Every member of a string enum of the API, for checking responses at run time. Pass an
 * object with one `true` per member: the compiler rejects a missing or an extra member.
 */
export function enumMembers<T extends string>(membership: Readonly<Record<T, true>>): readonly T[] {
  // The keys of a `Record<T, true>` literal are exactly the members of T.
  return Object.keys(membership) as T[];
}
